import { createFileRoute } from "@tanstack/react-router";
import { AuthorMappingDetailPage } from "@/components/admin/author-mapping/detail-page";

export const Route = createFileRoute("/_app/admin/author-mapping/$authorId")({
  component: Page,
});

function Page() {
  const { authorId } = Route.useParams();
  return <AuthorMappingDetailPage authorId={authorId} />;
}
